import { useQuery } from "@tanstack/react-query";

import { reviewsPubliekApi } from "@/lib/api";
import type { ReviewsScoreAntwoord } from "@/types/api";

export const reviewsScoreKeys = {
  all: ["reviews-score"] as const,
};

/** Live reviewstand voor het eigen WebwinkelKeur-blok (17-08).
 *
 * De server cachet zwaar (zes uur) en heeft zelf een terugval op de
 * laatst bekende stand, dus hier is een lange staleTime genoeg — één
 * ophaal per paginabezoek. Faalt de call alsnog, dan geeft de hook
 * lege waarden terug: het blok blijft dan staan met sterren, logo en
 * link, alleen zonder cijfer. Nooit een gat op de pagina.
 */
export function useReviewsScore(): {
  score: number | null;
  aantal: number | null;
} {
  const { data } = useQuery<ReviewsScoreAntwoord>({
    queryKey: reviewsScoreKeys.all,
    queryFn: () => reviewsPubliekApi.score(),
    staleTime: 60 * 60 * 1000,
    gcTime: 6 * 60 * 60 * 1000,
    retry: 1,
  });
  return {
    score: data?.score ?? null,
    aantal: data?.aantal ?? null,
  };
}
